import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";

enum EsateInventoryEnum {
  setValue = "/set-value",
  returnToAnalysis = "/return/analysis-estate-inventory"
}

export default class EstateInventoryService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/estate-inventory");
  }

  public postSetValue = async (tradeId: number, payload): Promise<any> => await this.PUT(EsateInventoryEnum.setValue + `/${tradeId}`, payload);

  public returnToAnalysis = async (tradeId: number): Promise<any> => await this.PUT(EsateInventoryEnum.returnToAnalysis + `/${tradeId}`);
}
